import { render, staticRenderFns } from "./addReport.vue?vue&type=template&id=ddd01bea&scoped=true&"
import script from "./addReport.vue?vue&type=script&lang=js&"
export * from "./addReport.vue?vue&type=script&lang=js&"
import style0 from "./addReport.vue?vue&type=style&index=0&id=ddd01bea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd01bea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddd01bea')) {
      api.createRecord('ddd01bea', component.options)
    } else {
      api.reload('ddd01bea', component.options)
    }
    module.hot.accept("./addReport.vue?vue&type=template&id=ddd01bea&scoped=true&", function () {
      api.rerender('ddd01bea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/addReport.vue"
export default component.exports